import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

function Processor({ label, name, date }) {
  return (
    <>
      <tr>
        <td className="text-primary" colSpan={12}>
          <b>{label}</b>
        </td>
      </tr>
      <tr>
        <td className="text-dark" colSpan={8}>
          Name
        </td>
        <td colSpan={4}>
          <b>{name ? `${name}`.trim() : '-'}</b>
        </td>
      </tr>
      <tr>
        <td className="text-dark" colSpan={8}>
          Date
        </td>
        <td colSpan={4}>
          <b>{date || '-'}</b>
        </td>
      </tr>
    </>
  );
}

Processor.defaultProps = {
  label: '',
  name: '',
  date: '',
};

Processor.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  date: PropTypes.string,
};

function TransactionInformation({ data }) {
  const spanGap = 8;
  const transmitallNo = get(
    data,
    'included.bplsApplication.attributes.transmittal_no'
  );

  return (
    <>
      <div className="p-3" style={{ maxHeight: '700px', overflowY: 'scroll' }}>
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Permit Type
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.permit_type') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Transaction Type
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.transaction_type') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Date
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.transaction_date') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Status
              </td>
              <td colSpan={4}>
                <b>
                  {get(data, 'attributes.transaction_status') === 'FOR CHECKING'
                    ? get(data, 'included.bplsApplication.attributes.status')
                    : get(data, 'attributes.transaction_status') || '-'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Valid ID to Present
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.valid_id_to_present') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Transmittal No.
              </td>
              <td colSpan={4}>
                <b>{transmitallNo || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                TXN ID
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.txnid') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Reference No.
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.refno') || '-'}</b>
              </td>
            </tr>
            <Processor
              label="Assessing By"
              name={get(data, 'attributes.assessing_by_fullname')}
              date={get(data, 'attributes.start_assess_at')}
            />
            <Processor
              label="Approved By"
              name={get(data, 'attributes.approve_by_full_name')}
              date={get(data, 'attributes.approve_at')}
            />
            <Processor
              label="Rejected By"
              name={get(data, 'attributes.reject_by_full_name')}
              date={get(data, 'attributes.reject_at')}
            />
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Remarks
              </td>
              <td colSpan={4}>
                <b>
                  <pre style={{ color: '#7790cb' }}>
                    {get(
                      data,
                      'included.bplsApplication.attributes.reject_remarks'
                    ) || '-'}
                  </pre>
                </b>
              </td>
            </tr>
            <Processor
              label="Released By"
              name={get(data, 'attributes.released_by_full_name')}
              date={get(data, 'attributes.released_at')}
            />
            <Processor
              label="SOA generated By"
              name={get(
                data,
                'included.bplsApplication.attributes.soa_generated_by'
              )}
              date={get(
                data,
                'included.bplsApplication.attributes.soa_generated_at'
              )}
            />
            <tr>
              <td className="text-primary" colSpan={spanGap}>
                <b>Payment Information</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Channel
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.payment_channel') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Branch
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.payment_channel_branch') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Date
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.payment_date') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Status
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.status') || '-'}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

TransactionInformation.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default TransactionInformation;
